export default __webpack_public_path__ + "media/images/icons/vimeo-79367bd1ffb81262c93b4b004f834fb1.svg";